import {AfterViewChecked, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DateTimeService} from '../../../services/date-time.service';
import {FormBuilder} from '@angular/forms';
import {BsLocaleService} from 'ngx-bootstrap/datepicker';
import {CustomValidator} from '../../../services/custom-validator';
import {BehaviorSubject} from 'rxjs';
import {HumanInteractionService} from '../../../services/human-interaction.service';

@Component({
  selector: 'app-business-process-invoke-filter',
  templateUrl: './business-process-invoke-filter.component.html',
  styleUrls: ['./business-process-invoke-filter.component.css']
})
export class BusinessProcessInvokeFilterComponent implements OnInit, AfterViewChecked {

  filterReportForm;
  customInteractQueueList: any[];
  customInteractQueueInfo;

  columnList: any[];

  columnInfo;
  columnValue;
  locale = 'pt-br';

  customId = '';
  enableFieldsCol = true;
  enableFieldsValue = false;
  enableAddButtonCol = false;
  hasOnlySpaces = false;

  @Input() objInitialState: any;
  @Input() columns: BehaviorSubject<any[]>;
  @Input() customInteraction: BehaviorSubject<any[]>;
  @Input() collapseFilter = false;
  @Output() filtered: EventEmitter<any> = new EventEmitter();

  get formData() { return this.filterReportForm.controls; }

  constructor(private dateTimeService: DateTimeService,
              private formBuilder: FormBuilder,
              private localeService: BsLocaleService,
              private humanInteractionService: HumanInteractionService) { }

  ngOnInit() {
    this.createForm();

    if (this.customInteraction) {
      this.customId = 'custom';
      this.enableColumns(false);
      this.customInteraction.asObservable()
        .subscribe(i => { this.customInteractQueueList = i; });
    }

    // baldão
    if (this.columns) {
      this.enableColumns(true);
      this.columns.asObservable()
        .subscribe(c => {
          if (c) {
            this.columnList = c.filter(f => f.systemField !== 5);
          }
        });
    }

    if (this.objInitialState) {
      if (this.objInitialState.lastFilter) {
        this.loadFilterData(this.objInitialState.lastFilter);
      }
    }
  }

  ngAfterViewChecked() {
    this.localeService.use(this.locale);
  }

  createForm() {
    this.filterReportForm = this.formBuilder.group({
      columnsComparisonType: 1,
      columns: [[]],
      initialDate: [null],
      finalDate: [null]
    }, { validators: [ CustomValidator.validateDatetime('initialDate', 'finalDate') ] });
  }

  loadFilterData(lastFilter) {
    if (!lastFilter) return;
    this.filterReportForm.patchValue({
      columnsComparisonType: lastFilter['columnsComparisonType'],
      columns: lastFilter['columns'],
      initialDate: this.dateTimeService.toLocalDateTimePickerFormat(lastFilter['initialDate']),
      finalDate: this.dateTimeService.toLocalDateTimePickerFormat(lastFilter['finalDate']),
    });
  }

  blockUserInput() {
    return false;
  }

  addColumnValue() {
    let array = this.filterReportForm.controls['columns'].value;
    if (this.customInteraction || (this.objInitialState && this.objInitialState.isCustomQueue)) {
      array.push({id: this.columnInfo.columnOrder + 1, name: this.columnInfo.name, value: this.columnValue.toString().trim()});
    } else { array.push({id: this.columnInfo.id, name: this.columnInfo.name, value: this.columnValue.toString().trim()}); }
    this.filterReportForm.controls['columns'].setValue(array);
    this.columnValue = "";
    this.enableAddButtonCol = false;
  }

  clearValue(event) {
    this.columnValue = "";
    // habilitar o campo de valor se houver alguma coluna selecionada.
    this.enableFieldsValue = event !== undefined;
    if (!this.enableFieldsValue) {
      this.hasOnlySpaces = false;
    }
    if (event === undefined) {
      this.enableAddButtonCol = false;
    }
  }

  removeColumnValue(item: any) {
    let array = this.filterReportForm.controls['columns'].value;
    array.splice(array.findIndex(v => v.value === item.value && v.id === item.id), 1);
    this.filterReportForm.controls['columns'].setValue(array);

  }


  search() {
    const filter = this.filterReportForm.getRawValue();
    filter.initialDate = this.dateTimeService.toUTC(filter.initialDate);
    filter.finalDate = this.dateTimeService.toUTC(filter.finalDate);

    if (this.customId === 'custom') {
      if (this.customInteractQueueInfo && filter.columns.length > 0) {
        filter.customInteractionQueueConfigId = [ this.customInteractQueueInfo.id ];
      } else {
        filter.customInteractionQueueConfigId = this.customInteractQueueList.map(m => m.id);
      }
    }

    this.collapseFilterWhenSearching();

    this.filtered.emit(filter);
  }

  collapseFilterWhenSearching() {
    if (this.collapseFilter) {
      // fechar o filtro
      const collapseFilter = document.getElementById(`collapseFilter${this.customId}`);
      collapseFilter.classList.add('fa-plus');
      collapseFilter.classList.remove('fa-minus');
      const bodyFilter = document.getElementById(`bodyFilter${this.customId}`);
      const footerFilter = document.getElementById(`footerFilter${this.customId}`);
      bodyFilter.style.display = footerFilter.style.display = 'none';
    }
  }

  resetFilter() {
    this.createForm();
    this.columnInfo = null;
    this.columnValue = null;
    this.enableFieldsValue = false;
    this.enableAddButtonCol = false;
  }

  disableSubmitButtonCondition() {
    return (this.formData.initialDate.value && !this.formData.finalDate.value)
      || (!this.formData.initialDate.value && this.formData.finalDate.value) || !this.filterReportForm.valid
      || (this.enableFieldsValue && this.columnValue !== '');
  }

  enableAddButton(event) {
    if (event.target.value.length > 0) {
      this.hasOnlySpaces = event.target.value.toString().trim() === '';
    } else {
      this.hasOnlySpaces = false;
    }

    this.enableAddButtonCol = event.target.value.toString().trim() !== '';
  }

  fillCustomColumns(event: any) {
    this.columnInfo = null;
    this.columnValue = null;
    this.filterReportForm.controls['columns'].setValue([]);
    if (event !== undefined) {
      this.enableColumns(true);
      this.getCustomInteractionQueueConfigById(event['id']);
    } else {
      this.enableColumns(false);
    }
  }

  enableColumns(value) {
    if (value) {
      this.filterReportForm.get('columnsComparisonType').enable();
      // this.filterReportForm.get('columns').enable();
    } else {
      this.filterReportForm.get('columnsComparisonType').disable();
      // this.filterReportForm.get('columns').disable();
    }
    this.enableFieldsCol = value;
  }

  getCustomInteractionQueueConfigById(id) {
    this.columnList = [];
    this.humanInteractionService.getCustomInteractionQueueConfigById(id).subscribe(c => {
      this.columnList = c.fieldColumns.filter(f => f.systemField !== 8 && f.systemField !== 5);
    });
  }

  validateRequiredColumnValue() {
    return (this.columnValue === '' || this.columnValue === undefined) && this.enableFieldsValue && !this.hasOnlySpaces;
  }
}
